import { Validators } from "@angular/forms";
import { IFormKey } from "src/app/modules/shared/models/forms";
import { options_yes_no } from "../registry-recap/registry-recap.constants";
import moment = require("moment");

// DATI ANAGRAFICI PERSONA FISICA

export const isv_contractor_registry_form_template = {
    cognome: null,
    nome: null,
    codiceFiscale: null,
    sesso: null,
    dataNascita: null,
    statoNascita: null,
    provinciaNascita: null,
    comuneNascita: null,
    cittadinanza: null,
    secondaCittadinanza: null,
    presenzaListaEsterne: null,
    svolgimentoRappContinuativo: null,
    svolgimentoOperazione: null,
    comportamentoCliente: null
}

export const isv_contractor_registry_form_validators = {
    cognome: [Validators.required],
    nome: [Validators.required],
    codiceFiscale: [Validators.required, Validators.pattern(/^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][A-Z0-9]{4}$/)],
    sesso: [Validators.required],
    dataNascita: [Validators.required],
    statoNascita: [Validators.required],
    provinciaNascita: [Validators.required],
    comuneNascita: [Validators.required],
    cittadinanza: [Validators.required],
    secondaCittadinanza: null,
    presenzaListaEsterne: [Validators.required],
    svolgimentoRappContinuativo: [Validators.required],
    svolgimentoOperazione: [Validators.required],
    comportamentoCliente: [Validators.required]
}

export const isv_new_contractor_registry_form_validators = {
    cognome: [Validators.required],
    nome: [Validators.required],
    codiceFiscale: [Validators.required, Validators.pattern(/^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][A-Z0-9]{4}$/)],
    sesso: [Validators.required],
    dataNascita: [Validators.required],
    statoNascita: [Validators.required],
    provinciaNascita: [Validators.required],
    comuneNascita: [Validators.required],
    ragioneSociale: [Validators.required],
    partitaIva: [Validators.required],
    holderRelationship: [Validators.required],
    cittadinanza: [Validators.required],
    comportamentoCliente: [Validators.required]
}

export const isv_contractor_registry_form_keys: IFormKey[] = [
    {
        id: 'cognome-field',
        label: 'Cognome',
        controlName: 'cognome',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'nome-field',
        label: 'Nome',
        controlName: 'nome',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'codice-fiscale-field',
        label: 'Codice fiscale',
        controlName: 'codiceFiscale',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'sesso-field',
        label: 'Sesso',
        controlName: 'sesso',
        css: 'col-3',
        type: 'SELECT',
        options: [
            {
                key: 'M',
                value: 'Maschio'
            },
            {
                key: 'F',
                value: 'Femmina'
            },
        ]
    },
    {
        id: 'data-nascita-field',
        controlName: 'dataNascita',
        label: 'Data di nascita',
        css: 'col-3',
        type: 'DATEPICKER',
        maxDate: moment()
    },
    {
        id: 'stato-nascita-field',
        label: 'Stato di nascita',
        controlName: 'statoNascita',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'provincia-nascita-field',
        label: 'Provincia di nascita',
        controlName: 'provinciaNascita',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'comune-nascita-field',
        label: 'Comune di nascita',
        controlName: 'comuneNascita',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'cittadinanza-field',
        label: 'Cittadinanza 1',
        controlName: 'cittadinanza',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'seconda-cittadinanza-field',
        label: 'Cittadinanza 2',
        controlName: 'secondaCittadinanza',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'presenza-lista-esterne-field',
        label: 'Presenza liste esterne',
        controlName: 'presenzaListaEsterne',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'comportamento-cliente-field',
        label: "Comportamento tenuto dal cliente",
        controlName: 'comportamentoCliente',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'rapporto-continuativo-field',
        label: 'Modalità di svolgimento del rapporto continuativo',
        controlName: 'svolgimentoRappContinuativo',
        css: 'col-6',
        type: 'SELECT',
        options: []
    },
    {
        id: 'svolgimento-operazione-field',
        label: "Modalità di svolgimento dell'operazione",
        controlName: 'svolgimentoOperazione',
        css: 'col-6',
        type: 'SELECT',
        options: []
    }
];
export const isv_new_contractor_registry_form_keys: IFormKey[] = [
    {
        id: 'cognome-field',
        label: 'Cognome',
        controlName: 'cognome',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'nome-field',
        label: 'Nome',
        controlName: 'nome',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'codice-fiscale-field',
        label: 'Codice fiscale',
        controlName: 'codiceFiscale',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'sesso-field',
        label: 'Sesso',
        controlName: 'sesso',
        css: 'col-3',
        type: 'SELECT',
        options: [
            {
                key: 'M',
                value: 'Maschio'
            },
            {
                key: 'F',
                value: 'Femmina'
            },
        ]
    },
    {
        id: 'data-nascita-field',
        controlName: 'dataNascita',
        label: 'Data di nascita',
        css: 'col-3',
        type: 'DATEPICKER',
        maxDate: moment()
    },
    {
        id: 'stato-nascita-field',
        label: 'Stato di nascita',
        controlName: 'statoNascita',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'provincia-nascita-field',
        label: 'Provincia di nascita',
        controlName: 'provinciaNascita',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'comune-nascita-field',
        label: 'Comune di nascita',
        controlName: 'comuneNascita',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'cittadinanza-field',
        label: 'Cittadinanza 1',
        controlName: 'cittadinanza',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'holderRelationship-field',
        label: 'Relazione con il vecchio contraente',
        controlName: 'holderRelationship',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'comportamento-cliente-field',
        label: "Comportamento tenuto dal cliente",
        controlName: 'comportamentoCliente',
        css: 'col-3',
        type: 'SELECT',
        options: []
    }
];

export const isv_new_contractor_PG_registry_form_keys: IFormKey[] = [
    {
        id: 'ragioneSociale-field',
        label: 'Ragione sociale',
        controlName: 'ragioneSociale',
        css: 'col-5',
        type: 'INPUT'
    },
    {
        id: 'partitaIva-field',
        label: 'Partita IVA',
        controlName: 'partitaIva',
        css: 'col-4',
        type: 'INPUT'
    },
    {
        id: 'data-costituzione-field',
        controlName: 'dataNascita',
        label: 'Data di costituzione',
        css: 'col-3',
        type: 'DATEPICKER',
        maxDate: moment()
    },
    {
        id: 'holderRelationship-field',
        label: 'Relazione con il vecchio contraente',
        controlName: 'holderRelationship',
        css: 'col-3',
        type: 'SELECT',
        options: []
    }
];

export const isv_PG_contractor_registry_form_keys: IFormKey[] = [
    {
        id: 'denominazione-field',
        label: 'Denominazione',
        controlName: 'denominazione',
        css: 'col-6',
        type: 'INPUT'
    },
    {
        id: 'partitaIva-field',
        label: 'Partita IVA',
        controlName: 'partitaIva',
        css: 'col-6',
        type: 'INPUT'
    },
    {
        id: 'data-nascita-field',
        controlName: 'dataNascita',
        label: 'Data di costituzione',
        css: 'col-3',
        type: 'DATEPICKER',
        maxDate: moment()
    },
    {
        id: 'presenza-lista-esterne-field',
        label: 'Presenza liste esterne',
        controlName: 'presenzaListaEsterne',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
];

export const isv_contractor_business_form_validators = {
    codiceSae: [Validators.required],
    codiceTae: null,
    codiceAteco: [Validators.required],
    activityType: [Validators.required],
    fasciaReddito: [Validators.required]
}

export const isv_new_contractor_business_form_validators = {
    codiceSae: [Validators.required],
    codiceAteco: [Validators.required],
    activityType: [Validators.required],
    codiceTae: null
}

export const isv_PG_contractor_business_form_validators = {
    classeBeneficiariSuCuiSiRivolgonoLeAttivita: [Validators.required],
    codiceAteco: [Validators.required],
    tipoSocietaImpresa: [Validators.required],
    codiceSae: [Validators.required],
    fasciaReddito: [Validators.required]
}

export const isv_contractor_business_form_keys: IFormKey[] = [
    {
        id: 'codice-sae-field',
        label: 'Codice S.A.E.',
        controlName: 'codiceSae',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'codice-ateco-field',
        label: 'Codice ATECO',
        controlName: 'codiceAteco',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'fascia-reddito-field',
        label: 'Fascia di reddito / Fatturato del contraente',
        controlName: 'fasciaReddito',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'ticpologia-attivita-field',
        label: 'Tipologia attività',
        controlName: 'activityType',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'codice-tae-field',
        label: 'Codice T.A.E.',
        controlName: 'codiceTae',
        css: 'col-4',
        type: 'SELECT',
        options: []
    }
];

export const isv_new_contractor_business_form_keys: IFormKey[] = [
    {
        id: 'codice-sae-field',
        label: 'Codice S.A.E.',
        controlName: 'codiceSae',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'codice-tae-field',
        label: 'Codice T.A.E.',
        controlName: 'codiceTae',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'codice-ateco-field',
        label: 'Codice ATECO',
        controlName: 'codiceAteco',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'ticpologia-attivita-field',
        label: 'Tipologia attività',
        controlName: 'activityType',
        css: 'col-4',
        type: 'SELECT',
        options: []
    }
];

export const isv_PG_new_contractor_business_form_keys: IFormKey[] = [
    {
        id: 'codice-sae-field',
        label: 'Codice S.A.E.',
        controlName: 'codiceSae',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'codice-ateco-field',
        label: 'Codice ATECO',
        controlName: 'codiceAteco',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
        {
        id: 'tipoSocietaImpresa-attivita-field',
        label: 'Tipologia Società/Impresa',
        controlName: 'tipoSocietaImpresa',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'classe-beneficiario-field',
        label: 'Beneficiari su cui si rivolgono le attività',
        controlName: 'classeBeneficiariSuCuiSiRivolgonoLeAttivita',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'fascia-reddito-field',
        label: 'Fascia di reddito / Fatturato del contraente',
        controlName: 'fasciaReddito',
        css: 'col-4',
        type: 'SELECT',
        options: []
    }
];

const privacy_options = [
    {
        key: 'SI',
        value: 'Presto il consenso'
    },
    {
        key: 'NO',
        value: 'Nego il consenso'
    },
    {
        key: 'NO RESPONSE',
        value: 'Non rispondo'
    }
];

const privacy1_label = `Tenuto conto dell’Informativa resami ai sensi degli articoli 13 e 14 del Regolamento UE 679/2016 da Intesa Sanpaolo Assicurazioni S.p.A., riportata nelle pagine precedenti, con riferimento al trattamento per le finalità promo-commerciali:`;

const privacy2_label = `Al trattamento dei miei Dati Personali a fini di informazione commerciale, offerte dirette, indagini di mercato o di customer satisfaction relative a prodotti e servizi della Società e di società del Gruppo Intesa Sanpaolo:`;

const privacy3_label = "Alla comunicazione dei miei Dati Personali ad altre società del Gruppo Intesa Sanpaolo (quali Assicurazioni, Banche, SIM, SGR), per lo svolgimento da parte loro di attività funzionali alla promozione e vendita di prodotti e/o servizi e di indagini di mercato, di customer satisfaction e di comunicazione commerciale:";

const privacy1_label_PG = `Letta l'Informativa nei confronti di persone giuridiche, enti o associazioni, rilasciata da Intesa Sanpaolo Vita e riportata nelle pagine precedenti,
in merito all'uso di sistemi automatizzati di chiamata o di comunicazione di chiamata senza l'operatore e di comunicazioni elettroniche (posta
elettronica, telefax, SMS, MMS o di altro tipo) per lo svolgimento di attività promozionali o il compimento di ricerche di mercato nei nostri
confronti effettuate da parte della Società e delle altre società del Gruppo Intesa Sanpaolo, a cui i nostri dati siano stati ceduti, in via autonoma
o avvalendosi di soggetti terzi appositamente incaricati.`;

export const isv_contractor_consents_form_keys: IFormKey[] = [
    {
        id: 'privacy1-field',
        label: privacy1_label,
        controlName: 'privacy1',
        css: 'col-12',
        type: 'RADIO',
        options: [
            {
                key: 'SI',
                value: 'Presto il consenso'
            },
            {
                key: 'NO',
                value: 'Nego il consenso'
            }
        ],
        wrapOptions: true
    },
    {
        id: 'privacy2-field',
        label: privacy2_label,
        controlName: 'privacy2',
        css: 'col-12',
        type: 'RADIO',
        options: privacy_options,
        wrapOptions: true
    },
    {
        id: 'privacy3-field',
        label: privacy3_label,
        controlName: 'privacy3',
        css: 'col-12',
        type: 'RADIO',
        options: privacy_options,
        wrapOptions: true
    }
];

export const isv_contractor_PG_consents_form_keys: IFormKey[] = [
    {
        id: 'privacy1-field',
        label: privacy1_label_PG,
        controlName: 'privacy1',
        css: 'col-12',
        type: 'RADIO',
        options: privacy_options,
        wrapOptions: true
    }
];

// DATI ANAGRAFICI PERSONA GIURIDICA

export const isv_legal_subject_contractor_registry_form_template = {
    ragioneSociale: { value: null, disabled: true },
    codiceFiscale: { value: null, disabled: true }
}

export const isv_legal_subject_contractor_registry_form_validators = {
    ragioneSociale: [Validators.required],
    codiceFiscale: [Validators.required, Validators.pattern(/^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][A-Z0-9]{4}$/)],
}

export const isv_legal_subject_contractor_registry_form_keys: IFormKey[] = [
    {
        id: 'ragione-sociale-field',
        label: 'Ragione Sociale',
        controlName: 'ragioneSociale',
        css: 'col-4',
        type: 'INPUT'
    },
    {
        id: 'codice-fiscale-field',
        label: 'Codice fiscale',
        controlName: 'codiceFiscale',
        css: 'col-3',
        type: 'INPUT'
    }
];

export const isv_PG_contractor_business_form_keys: IFormKey[] = [
    {
        id: 'codice-sae-field',
        label: 'Codice S.A.E.',
        controlName: 'codiceSae',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'codice-ateco-field',
        label: 'Codice ATECO',
        controlName: 'codiceAteco',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'tipoSocietaImpresa-attivita-field',
        label: 'Tipologia Società/Impresa',
        controlName: 'tipoSocietaImpresa',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'classe-beneficiario-field',
        label: 'Beneficiari su cui si rivolgono le attività',
        controlName: 'classeBeneficiariSuCuiSiRivolgonoLeAttivita',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'fascia-reddito-field',
        label: 'Fascia di reddito / Fatturato del contraente',
        controlName: 'fasciaReddito',
        css: 'col-4',
        type: 'SELECT',
        options: []
    }
];

// RESIDENZA
export const isv_contractor_residence_form_template = {
    stato: null,
    localita: {value: null, disabled: true},
    provincia: {value: null, disabled: true},
    cap: {value: null, disabled: true},
    indirizzo: {value: null, disabled: true}
}

export const isv_contractor_residence_form_validators = {
    stato: [Validators.required],
    localita: [Validators.required],
    provincia: [Validators.required],
    cap: [Validators.required, Validators.pattern(/^\d{5}$/)],
    indirizzo: [Validators.required]
}

export const isv_contractor_residence_form_validators_previdential = {
    stato: [Validators.required],
    localita: [Validators.required],
    provincia: [Validators.required],
    cap: [Validators.required, Validators.pattern(/^\d{5}$/)],
    indirizzo: [Validators.required],
    civico: [Validators.required]
}

export const isv_contractor_residence_form_keys: IFormKey[] = [
    {
        id: 'stato-field',
        label: 'Nazione',
        controlName: 'stato',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'provincia-field',
        label: 'Provincia',
        controlName: 'provincia',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'localita-field',
        label: 'Città',
        controlName: 'localita',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'cap-field',
        label: 'CAP',
        controlName: 'cap',
        css: 'col-3'
    },
    {
        id: 'indirizzo-field',
        label: 'Indirizzo',
        controlName: 'indirizzo',
        css: 'col-6'
    }
];

// RECAPITO
export const isv_contractor_address_form_template = {
    sameAsResidence: null,
    stato: null,
    localita: {value: null, disabled: true},
    provincia: {value: null, disabled: true},
    cap: {value: null, disabled: true},
    indirizzo: {value: null, disabled: true}
}

export const isv_contractor_address_form_validators = {
    sameAsResidence: null,
    stato: [Validators.required],
    localita: [Validators.required],
    provincia: [Validators.required],
    cap: [Validators.required, Validators.pattern(/^\d{5}$/)],
    indirizzo: [Validators.required]
}

export const isv_contractor_address_form_keys: IFormKey[] = [
    {
        id: 'same-residence-field',
        label: 'Stesso indirizzo di residenza',
        controlName: 'sameAsResidence',
        css: 'col-3',
        type: 'CHECKBOX'
    },
    {
        id: 'address-new-line-field',
        label: null,
        controlName: null,
        type: 'NEW_LINE',
        css: 'col-12'
    },
    {
        id: 'stato-field',
        label: 'Nazione',
        controlName: 'stato',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'provincia-field',
        label: 'Provincia',
        controlName: 'provincia',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'localita-field',
        label: 'Città',
        controlName: 'localita',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'cap-field',
        label: 'CAP',
        controlName: 'cap',
        css: 'col-3'
    },
    {
        id: 'indirizzo-field',
        label: 'Indirizzo',
        controlName: 'indirizzo',
        css: 'col-6'
    }
];

export const effective_owner_registry_form_validators = {
    cognome: [Validators.required],
    nome: [Validators.required],
    codiceFiscale: [Validators.required, Validators.pattern(/^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][A-Z0-9]{4}$/)],
    sesso: [Validators.required],
    dataNascita: [Validators.required],
    statoNascita: [Validators.required],
    provinciaNascita: [Validators.required],
    comuneNascita: [Validators.required],
    sae: [Validators.required],
    ateco: [Validators.required],
    isPEP: [Validators.required],
    cittadinanza: [Validators.required],
    secondaCittadinanza: null,
    comportamentoCliente: [Validators.required]
}

export const effective_owner_registry_form_keys: IFormKey[] = [
    {
        id: 'cognome-field',
        label: 'Cognome',
        controlName: 'cognome',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'nome-field',
        label: 'Nome',
        controlName: 'nome',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'codice-fiscale-field',
        label: 'Codice fiscale',
        controlName: 'codiceFiscale',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'sesso-field',
        label: 'Sesso',
        controlName: 'sesso',
        css: 'col-3',
        type: 'SELECT',
        options: [
            {
                key: 'M',
                value: 'Maschio'
            },
            {
                key: 'F',
                value: 'Femmina'
            },
        ]
    },
    {
        id: 'data-nascita-field',
        controlName: 'dataNascita',
        label: 'Data di nascita',
        css: 'col-3',
        type: 'DATEPICKER',
        maxDate: moment()
    },
    {
        id: 'stato-nascita-field',
        label: 'Stato di nascita',
        controlName: 'statoNascita',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'provincia-nascita-field',
        label: 'Provincia di nascita',
        controlName: 'provinciaNascita',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'comune-nascita-field',
        label: 'Comune di nascita',
        controlName: 'comuneNascita',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'cittadinanza-field',
        label: 'Cittadinanza 1',
        controlName: 'cittadinanza',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'seconda-cittadinanza-field',
        label: 'Cittadinanza 2',
        controlName: 'secondaCittadinanza',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'effective-owner-isPEP-field',
        label: 'Presenza nelle liste esterne',
        controlName: 'isPEP',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'effective-owner-comportamentoCliente-field',
        label: 'Comportamento tenuto dal cliente',
        controlName: 'comportamentoCliente',
        css: 'col-3',
        type: 'SELECT',
        options: []
    }
];

export const privacy_consents_form_template = {
   privacy1: null,
   privacy2: null,
   privacy3: null
}

export const privacy_consents_form_validators = {
   privacy1: [Validators.required],
   privacy2: [Validators.required],
   privacy3: [Validators.required]
}

export const privacy_consents_PG_form_template = {
   privacy1: null
}

export const privacy_consents_PG_form_validators = {
   privacy1: [Validators.required]
}

export const proper_verification_form_template = {
   profession: null,
   fasciaReddito: null,
   isPEP: null,
   publicFunds: null
}

export const proper_verification_form_validators = {
   profession: [Validators.required],
   fasciaReddito: [Validators.required],
   isPEP: null,
   publicFunds: [Validators.required]
}

export const proper_verification_form_keys: IFormKey[] = [
    {
        id: 'profession-field',
        label: 'Professione',
        controlName: 'profession',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'fasciaReddito-field',
        label: 'Fascia di reddito / Fatturato del contraente',
        controlName: 'fasciaReddito',
        css: 'col-4',
        type: 'SELECT',
        options: []
    },
    {
        id: 'isPEP-field',
        label: 'È una "Persona Esposta Politicamente"',
        controlName: 'isPEP',
        css: 'col-6',
        type: 'CHECKBOX'
    },
    {
        id: 'publicFunds-field',
        label: "Il cliente opera in settori economici interessati dall'erogazione di fondi pubblici?",
        controlName: 'publicFunds',
        css: 'col-12',
        type: 'RADIO',
        options: options_yes_no
    },
    {
        id: 'ownership-new-line-field',
        label: "Titolarità di cariche ricoperte",
        controlName: null,
        type: 'NEW_LINE',
        css: 'col-12'
    }
];

export const isv_legal_guardian_registry_form_validators = {
    cognome: [Validators.required],
    nome: [Validators.required],
    sesso: [Validators.required],
    codiceFiscale: [Validators.required],
    codiceSae: [Validators.required],
    codiceAteco: [Validators.required],
    dataNascita: [Validators.required],
    statoNascita: [Validators.required],
    provinciaNascita: [Validators.required],
    comuneNascita: [Validators.required],
    cittadinanza: [Validators.required],
    secondaCittadinanza: null,
    isPEP: [Validators.required],
    relazioneContraenteEsecutore: [Validators.required],
    comportamentoCliente: [Validators.required],
    tipoDelega: [Validators.required]
}

export const isv_legal_guardian_registry_form_keys: IFormKey[] = [
    {
        id: 'cognome-field',
        label: 'Cognome',
        controlName: 'cognome',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'nome-field',
        label: 'Nome',
        controlName: 'nome',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'codice-fiscale-field',
        label: 'Codice fiscale',
        controlName: 'codiceFiscale',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'sesso-field',
        label: 'Sesso',
        controlName: 'sesso',
        css: 'col-3',
        type: 'SELECT',
        options: [
            {
                key: 'M',
                value: 'Maschio'
            },
            {
                key: 'F',
                value: 'Femmina'
            },
        ]
    },
    {
        id: 'data-nascita-field',
        controlName: 'dataNascita',
        label: 'Data di nascita',
        css: 'col-3',
        type: 'DATEPICKER',
        maxDate: moment()
    },
    {
        id: 'stato-nascita-field',
        label: 'Stato di nascita',
        controlName: 'statoNascita',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'provincia-nascita-field',
        label: 'Provincia di nascita',
        controlName: 'provinciaNascita',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'comune-nascita-field',
        label: 'Comune di nascita',
        controlName: 'comuneNascita',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'cittadinanza-field',
        label: 'Cittadinanza 1',
        controlName: 'cittadinanza',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'seconda-cittadinanza-field',
        label: 'Cittadinanza 2',
        controlName: 'secondaCittadinanza',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'presenza-lista-esterne-field',
        label: 'Presenza liste esterne',
        controlName: 'isPEP',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'relazioneContraenteEsecutore-field',
        label: "Relazione contraente esecutore",
        controlName: 'relazioneContraenteEsecutore',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'comportamento-cliente-field',
        label: "Comportamento tenuto dal cliente",
        controlName: 'comportamentoCliente',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'tipoDelega-field',
        label: "Tipo delega",
        controlName: 'tipoDelega',
        css: 'col-3',
        type: 'SELECT',
        options: []
    }
];

export const proper_verification_tutor_form_keys: IFormKey[] = [
    {
        id: 'profession-field',
        label: 'Professione',
        controlName: 'profession',
        css: 'col-6',
        type: 'SELECT',
        options: []
    },
    {
        id: 'isPEP-field',
        label: 'È una "Persona Esposta Politicamente"',
        controlName: 'isPEP',
        css: 'col-6',
        type: 'CHECKBOX'
    }
];
